import Cookies from 'js-cookie'

export const acceptPrivacyPolicy = () => {
  Cookies.set('acceptedPrivacyPolicyVersion', '01/07/2024')
}
